import DataUserLoyalty from "../store/DataUserLoyalty";

export async function fetchData(data) {
    try {
        const response = await fetch(
            "https://uvjwfdf5aa.execute-api.eu-west-1.amazonaws.com/test/guest-login",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: data,
            }
        );

        const result = await response.json();
        DataUserLoyalty.userData = result.body;
        console.log(result);
        if (result.statusCode == 200) {
            localStorage.setItem("user", JSON.stringify(result.body));
        }
        return result;
    } catch (e) {
        console.log(e);
        throw new Error(e);
    }
}
